<template>
  <div>
    <v-card min-height="100vh">
      <v-toolbar style="background-color: #3e682a; color: #fff">
        <v-btn icon dark @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <span class="headline">Prontuários</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loadingPdf"
          :disabled="loadingPdf"
          :dark="!loadingPdf"
          color="#b64343"
          class="ma-2 white--text"
          @click="gerarPdf()"
        >
          Gerar PDF
          <v-icon right dark>
            mdi-file-download
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-card class="mb-6" elevation="1">
            <div class="row">
              <div class="col-4">
                <h4 class="px-4"><strong>Nome:</strong> {{ paciente.nome }}</h4>
              </div>
              <div class="col-4">
                <h4 class="px-4"><strong>Cpf:</strong> {{ paciente.cpf }}</h4>
              </div>
              <div class="col-4">
                <h4 class="px-4">
                  <strong>Email:</strong> {{ paciente.email }}
                </h4>
              </div>
            </div>
          </v-card>
          <v-expansion-panels v-model="panel">
            <v-expansion-panel
              @click="initConsulta(item, i)"
              v-for="(item, i) in consultas"
              :key="i"
            >
              <v-expansion-panel-header v-slot="{ open }">
                <v-row no-gutters>
                  <v-col cols="4" class="align-self-center">
                    Data: {{ item.data | data }}
                  </v-col>
                  <v-col cols="8" class="text--secondary">
                    <v-fade-transition leave-absolute>
                      <span v-if="open" key="0" class="d-flex">
                        <v-col cols="10" class="align-self-center">
                          Procedimento:{{ item.procedimento }}
                        </v-col>
                      </span>
                      <span v-else key="1" class="d-flex">
                        <v-col cols="7" class="align-self-center">
                          {{ item.procedimento }}
                        </v-col>
                        <v-col cols="5"> Há {{ calcular_tempo(item) }} </v-col>
                      </span>
                    </v-fade-transition>
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <template>
                  <v-card elevation="0">
                    <v-tabs color="green darken-4">
                      <v-tab>
                        <h5>Resumo</h5>
                      </v-tab>
                      <!-- <v-tab v-if="classificarFotos3 > 0">
                        <h5>Classificar fotos</h5>
                      </v-tab>
                      <v-tab v-if="Fotosclassificadas1 > 0">
                        <h5>Antes e depois</h5>
                      </v-tab> -->

                      <!-- RESUMO -->
                      <v-tab-item>
                        <v-card flat :loading="loading">
                          <v-card-text>
                            <v-row
                              no-gutters
                              class="text-left flex-column"
                              v-if="!loading"
                            >
                              <v-row class="justify-end">
                                <v-btn
                                  color="green darken-3"
                                  small
                                  v-if="!isBeforeOrToday(item.data)"
                                  @click="editar = !editar"
                                >
                                  <v-icon v-if="editar" color="#ffffff">
                                    mdi-pencil
                                  </v-icon>
                                  <v-icon v-else color="#ffffff">
                                    mdi-close
                                  </v-icon>
                                </v-btn>
                              </v-row>
                              <v-row class="flex-column">
                                <label for="resumo"
                                  ><strong>Resumo: </strong>
                                </label>
                                <v-text-field
                                  :disabled="editar"
                                  id="resumo"
                                  v-model="consulta.consulta_descricao"
                                ></v-text-field>
                              </v-row>
                              <v-row class="flex-column">
                                <div
                                  v-for="(pergunta,
                                  index) in consulta.perguntas"
                                  :key="index"
                                >
                                  <consulta-fill
                                    @rchange="atributeModel"
                                    :pergunta="pergunta"
                                    :disabled="!editar"
                                  />
                                </div>
                              </v-row>
                              <v-row class="flex-column">
                                <v-col
                                  ><v-btn
                                    color="green darken-3"
                                    @click="atualizarProntuario"
                                    v-if="!editar"
                                  >
                                    <v-icon color="#ffffff">
                                      mdi-pencil
                                    </v-icon>
                                    <span style="color: #ffffff"
                                      >Salvar alterações</span
                                    >
                                  </v-btn></v-col
                                >
                              </v-row>

                              <v-row class="flex-column">
                                <h4 class="pl-3">Adendos</h4>
                              </v-row>

                              <v-row class="flex-column">
                                <p
                                  class="adendo"
                                  :key="adendo.id"
                                  v-for="adendo in adendos"
                                >
                                  <span
                                    >{{
                                      adendo.data
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                    }}
                                    - {{ adendo.hora }}</span
                                  >
                                  {{ adendo.descricao }}
                                </p>
                              </v-row>

                              <v-row class="flex-column">
                                <v-col>
                                  <v-text-field
                                    v-model="adendo[i]"
                                  ></v-text-field>
                                </v-col>

                                <v-col>
                                  <v-btn
                                    @click="addAdendo(i)"
                                    class="green darken-1 white--text"
                                    >Adicionar</v-btn
                                  >
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs>
                  </v-card>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import FotosClassificadas from "@/components/prontuarios/fotos_classificadas.vue";
import ConsultaFill from "@/components/prontuarios/consulta_campo_fill.vue";
import ConsultaService from "@/services/consulta_service.js";
import ProntuarioService from "@/services/prontuario_service.js";
import AdendoService from "@/services/adendo_service.js";
import Mixin from "@/mixins/vuex_snackbar_mixin.js";

export default {
  mixins: [Mixin],
  components: {
    ConsultaFill,
    // FotosClassificadas,
  },

  props: {
    consultas: Array,
    paciente: Object,
  },
  beforeMount() {
    // console.log("consultas")
    // console.log(this.consultas)
    this.adendo = this.consultas.map(() => "");
  },
  data: () => ({
    //tab => Condicionais
    // classificarFotos1: 1,
    // Fotosclassificadas1: 2,
    // classificarFotos2: 2,
    // Fotosclassificadas2: 1,
    // classificarFotos3: 1,
    // Fotosclassificadas3: 1,
    adendo: [],
    adendos: [],
    // itens: [
    //   {
    //     procedimento: "Consulta",
    //     id_paciente:10,
    //     data: "01/02/2021",
    //   },
    //   {
    //     procedimento: "Cirurgia da face",
    //     id_paciente:10,
    //     data: "02/03/2021",

    //   },
    //   {
    //     procedimento: "Retorno",
    //     id_paciente:10,
    //     data: "03/04/2021",
    //   },
    // ],
    consulta: {},
    //  [
    //   {
    //     resumo: "Foi feito uma consulta ....",
    //     queixa: "Face.",
    //     antecedentes_clinicos: "Tabagismo - 5 anos",
    //     usa_medicamento: "Não",
    //     fez_cirurgia: "Sim, fez uma cirurgia no pé.",

    //   },
    //   {
    //     resumo: "Foi feito uma cirurgia ....",
    //     queixa: "Face.",
    //     antecedentes_clinicos: "Tabagismo - 5 anos",
    //     usa_medicamento: "Não",
    //     fez_cirurgia: "Sim, fez uma cirurgia no pé.",

    //   },
    //   {
    //     resumo: "Retorno ....",
    //     queixa: "Face.",
    //     antecedentes_clinicos: "Tabagismo - 5 anos",
    //     usa_medicamento: "Não",
    //     fez_cirurgia: "Sim, fez uma cirurgia no pé.",
    //   },
    // ],
    // consulta:{},
    panel: [],
    // loadingClassificarFotos:true,
    // loadingFotos:true,
    loading: true,
    loadingPdf: false,
    open: false,
    date: null,
    editar: true,
    trip: {
      name: "",
      location: null,
      start: null,
      end: null,
    },
    formularioEditar: {},
    plc: {},
    services: {
      prontuarioService: ProntuarioService.build(),
    },
  }),
  watch: {
    panel(index) {
      if (index >= 0) {
        this.consulta = {};
        this.carregar_item(index);
      } else {
        this.consulta = {};
      }
    },
  },
  methods: {
    initConsulta(item, index) {
      this.formularioEditar = item;
      this.listAdendos(index);
    },

    isBeforeOrToday(data) {
      const data_parts = data.split("-");
      const data_consulta = new Date(
        data_parts[0],
        data_parts[1],
        data_parts[2]
      );
      return data_consulta <= new Date();
    },

    atributeModel(change) {
      const newValue = change.alteracao;
      const perguntaId = change.pergunta.id;

      const pergunta = this.consulta.perguntas.find((e) => e.id === perguntaId);
      const respostaCampos = {
        1: "resposta_pergunta_textual",
        2: "resposta_pergunta_textual",
        3: "resposta_pergunta_opcao",
        4: "resposta_pergunta_opcao",
      };
      const respostaCampo = respostaCampos[pergunta.id_tipo_pergunta];
      pergunta[respostaCampo] = newValue;
    },
    atualizarProntuario() {
      let formulario = this.formularioEditar;

      formulario.id_consulta = Number.parseInt(
        this.formularioEditar.id_consulta
      );
      formulario.titulo = this.formularioEditar.consulta_titulo;
      formulario.descricao = this.consulta.consulta_descricao;
      formulario.id_formulario = this.consulta.formulario_id;

      formulario.respostas = this.consulta.perguntas.map((resposta) => {
        if (resposta.resposta_pergunta_textual) {
          resposta.resposta = resposta.resposta_pergunta_textual;
        }

        if (resposta.resposta_pergunta_decimal) {
          resposta.resposta = resposta.resposta_pergunta_decimal;
        }

        if (resposta.resposta_pergunta_inteira) {
          resposta.resposta = resposta.resposta_pergunta_inteira;
        }

        if (resposta.resposta_pergunta_opcao) {
          resposta.resposta = resposta.resposta_pergunta_opcao;
        }

        resposta.id_pergunta = resposta.id;

        return resposta;
      });

      this.plc = this.consulta;

      const consultaService = new ConsultaService();
      consultaService.update(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.form_resp = {};
              this.resp = [];
              this.$_ACTIONS_showSnackbarMessage({
                message: "Alterações salvas com sucesso",
                color: "sucess",
              });
              // this.$emit("finalizarConsulta", { msg:body.message, cor:"sucess", nome: this.paciente.nome} );
            } else {
              this.$_ACTIONS_showSnackbarMessage({
                message:
                  body.message || this.$global.messages.internalServerError,
                color: "error",
              });
            }
          },
          onError: (message) => {
            this.$_ACTIONS_showSnackbarMessage({
              message: message || this.$global.messages.internalServerError,
              color: "error",
            });
          },
          onEnd: () => {
            this.loadingNovoFormulario = false;
          },
        },
        formulario,
        formulario.id_consulta
      );
    },

    listAdendos(index) {
      const adendoService = new AdendoService();
      const consulta_id = this.consultas[index].id_consulta;

      adendoService.getList(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.adendos = body.data.adendos;
            }
          },
          onError: (error) => {
            console.log(error);
          },
          onEnd: () => {
            this.loading = false;
            this.adendo[index] = "";
          },
        },
        consulta_id
      );
    },

    addAdendo(index) {
      const adendoService = new AdendoService();

      const adendoVM = {
        consulta_id: this.consultas[index].id_consulta,
        descricao: this.adendo[index],
      };

      adendoService.criarAdendo(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.$_ACTIONS_showSnackbarMessage({
                message: body.message,
                color: "sucess",
              });

              this.listAdendos(index);
            }
          },
          onError: (error) => {
            this.$_ACTIONS_showSnackbarMessage({
              message: error.message,
              color: "error",
            });
          },
          onEnd: () => {
            this.adendo[index] = "";
          },
        },
        adendoVM
      );
    },

    calcular_tempo(i) {
      console.log(i);
      var data = new Date(i.data);
      var hj = new Date();
      var dif = hj.getTime() - data.getTime();
      var dias = dif / (1000 * 3600 * 24);
      dias = Math.floor(dias);
      var resp = "";
      if (dias > 120) {
        var meses = Math.floor(dias / 30);
        resp = meses + " meses";
        // console.log(dias);
        // var semanas = Math.floor(dias / 7);
        // dias -= semanas * 7;
        // resp = `${semanas} sem. e ${dias} dia(s) `;
        // if (semanas > 4) {
        //   var meses = Math.floor(semanas / 4);
        //   semanas -= meses * 4;
        //   resp = `${meses} m., ${semanas} sem. e ${dias} dia(s) `;
        //   if (meses > 12) {
        //     var anos = Math.floor(meses / 12);
        //     meses -= anos * 12;
        //     resp = `${anos} ano(s) , ${meses} m., ${semanas} sem. e ${dias} dia(s) `;
        //   }
        // }
      } else {
        resp = dias + " dia(s)";
      }
      return resp;
    },
    carregar_item(index) {
      const consultaService = new ConsultaService();
      consultaService.get(
        {
          onSucess: (status) => (body) => {
            if (status === 200) {
              this.consulta = body.data;
              console.log("this.consulta.perguntas");
              console.log(this.consulta.perguntas);
              console.log(this.consulta);
              console.log("this.consulta.perguntas");
            }
          },
          onError: (error) => {
            console.log(error);
          },
          onEnd: () => {
            this.loading = false;
          },
        },
        this.consultas[index].id_consulta
      );

      //  setTimeout(() =>  this.loading = false, 1000);
      //     this.consulta = this.consultas[index]
    },
    sem_fotos_para_classificar() {
      this.loadingClassificarFotos = false;
      this.$_ACTIONS_showSnackbarMessage({
        message: "Não coseguimos encontrar as fotos",
        color: "error",
      });
    },
    sem_fotos() {
      this.loadingFotos = false;
      this.$_ACTIONS_showSnackbarMessage({
        message: "Não coseguimos encontrar as fotos",
        color: "error",
      });
    },
    gerarPdf() {
      this.loadingPdf = true;
      const titulo = `Prontuários: ${
        this.paciente.nome
      } - ${this.paciente.cpf.replaceAll(".", "").replaceAll("-", "")}`;
      this.services.prontuarioService
        .pdfProntuariosbyPaciente(this.paciente.id_paciente)
        .then((resp) => {
          console.log("resp: ", resp);
          if (resp.status) {
            this.$_ACTIONS_showSnackbarMessage({
              message: "Falha ao carregar",
              color: "error",
            });
            return;
          }
          this.$_ACTIONS_showSnackbarMessage({
            message: "Dados encontrados com sucesso! Gerando PDF...",
            color: "sucess",
          });
          let link = document.createElement("a");
          // link.target = "_blank";
          link.download = `${titulo}.pdf`;
          let url = window.URL.createObjectURL(resp);
          link.href = url;
          link.click();
        })
        .catch(() => {
          this.$_ACTIONS_showSnackbarMessage({
            message: "Falha ao carregar",
            color: "error",
          });
        })
        .finally(() => {
          this.loadingPdf = false;
        });
    },
  },
};
</script>

<style scoped>
p {
  margin: 0px 10px !important;
  padding: 0px 10px !important;
  font-size: 16px;
}
</style>
